/* Black Deer — Erişilebilirlik katmanı
   Klavye ve ekran okuyucu deneyimini iyileştirir.
   Görsel tasarımı değiştirmez. */
(function(){
  // 1. Klavye kullanımını işaretle (CSS kancası)
  document.addEventListener('keydown', function(e){
    if (e.key === 'Tab') document.documentElement.dataset.bdKlavye = 'evet';
  }, { once: true });
  document.addEventListener('mousedown', function(){
    delete document.documentElement.dataset.bdKlavye;
  });

  // 2. Tahmin araması: sonuç görünürlüğünü ekran okuyucuya bildir
  document.querySelectorAll('predictive-search-component').forEach(function(bilesen){
    var girdi = bilesen.querySelector('input[type="search"]');
    if (!girdi) return;
    function esitle(){
      var q = (girdi.value || '').trim();
      var sonucVar = !!bilesen.querySelector('[ref="resultsItems[]"], .predictive-search-results a');
      girdi.setAttribute('aria-expanded', String(q.length > 0 && sonucVar));
    }
    new MutationObserver(esitle).observe(bilesen, { childList: true, subtree: true });
    girdi.addEventListener('input', esitle, { passive: true });
    girdi.addEventListener('keydown', function(e){
      if (e.key === 'Escape') girdi.setAttribute('aria-expanded', 'false');
    });
    esitle();
  });

  // 3. Hareket azaltma tercihi: hero döngüsünü durdur
  function hareket(){
    var hero = document.querySelector('.bd-hero');
    if (!hero) return;
    var tercih = matchMedia('(prefers-reduced-motion: reduce)');
    function dur(){ hero.dispatchEvent(new Event('mouseenter')); }
    function bas(){ hero.dispatchEvent(new Event('mouseleave')); }
    if (tercih.matches) dur();
    if (tercih.addEventListener) {
      tercih.addEventListener('change', function(e){ e.matches ? dur() : (!document.hidden && bas()); });
    }
    // Sekme arka plandayken slayt dönmesin (pil ve işlemci tasarrufu)
    document.addEventListener('visibilitychange', function(){
      document.hidden ? dur() : (!tercih.matches && bas());
    });
  }

  // 4. Mobil sabit satın alma çubuğuna ekran okuyucu açıklaması
  //    DİKKAT: Burada eskiden '.bdbar' aranıyordu. O sınıfı üst duyuru şeridi
  //    (sections/bd-bar.liquid) de kullanıyor ve sayfada ondan önce yer alıyor.
  //    Sonuç: "Seçili ürün varyantını sepete ekler." açıklaması duyuru şeridine
  //    bağlanıyor, ekran okuyucuya yanlış bileşen tarif ediliyordu.
  //    Mobil çubuğun sınıfı artık '.bd-mbar' (snippets/bd2-mobil-bar.liquid).
  function cubukAciklama(){
    var bar = document.querySelector('.bd-mbar');
    if (!bar || document.getElementById('bd-bar-yardim')) return;
    var s = document.createElement('span');
    s.id = 'bd-bar-yardim';
    s.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)';
    s.textContent = 'Seçili ürün varyantını sepete ekler.';
    bar.appendChild(s);
    bar.setAttribute('aria-describedby', 'bd-bar-yardim');
  }

  // 5. Modal açıldığında odağı içeride tut
  function odakTuzagi(){
    document.addEventListener('keydown', function(e){
      if (e.key !== 'Tab') return;
      var modal = document.querySelector('.bdq[data-acik="1"], .bdsb[data-acik="1"], .bdck[data-acik="1"], .bdsg__ort[open]');
      if (!modal) return;
      var odaklanabilir = modal.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
      if (!odaklanabilir.length) return;
      var ilk = odaklanabilir[0], son = odaklanabilir[odaklanabilir.length - 1];
      if (e.shiftKey && document.activeElement === ilk) { e.preventDefault(); son.focus(); }
      else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
    });
  }

  function baslat(){ hareket(); cubukAciklama(); odakTuzagi(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  setTimeout(cubukAciklama, 1000);
})();
